<template>
  <div class="lstIzin">
    <div class="col-12">
      <div class="list-group">
        <div v-for="(item, index) in listOfizin" :key="index" class="py-1 px-2">
          <div class="list-group-item list-group-item-action">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">Izin</h5>
              <!-- <small class="text-muted">{{
                formatDatetime(item.created_on)
              }}</small> -->
            </div>
            <p class="mb-1">Diajukan Oleh : {{ item.nm_pegawai }}</p>
            <p class="mb-1">Tanggal : {{ formatDate(item.tanggal_awal) }}</p>
            <p class="mb-1">Keterangan : {{ item.keterangan }}</p>
            <div class="col-3" v-if="item.file_upload == 0">-</div>
            <div class="col-3 mx-3" v-else>
              <button class="btn" @click="openImg(img + item.file_upload)">
                <img
                  src="../../public/img/home/folder.png"
                  class="img-responsive d-block w60"
                />
              </button>
            </div>
            <small class="text-muted" v-if="item.status == 0">Pending</small>
            <small class="text-success" v-else-if="item.status == 1"
              >Disetujui</small
            >
            <small class="text-warning" v-else-if="item.status == 3">
              Dibatalkan
            </small>
            <small class="text-danger" v-else>Tidak Disetujui</small>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-succes btn-sm"
          :class="{ 'd-none': btnDisabled }"
          @click.prevent="loadMore(page)"
        >
          {{ btnLoadMoreName }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
const axios = require("axios");
const Swal = require("sweetalert2");
import moment from "moment";
export default {
  data() {
    return {
      page: 2,
      id: localStorage.getItem("id"),
      listOfizin: [],
      dataEmpty: true,
      btnDisabled: false,
      btnLoadMoreName: "Muat Lebih Banyak",
      nama: localStorage.getItem("nama"),
      kontak: "xxxxxxx",
      tglsaatini: new Date().toISOString().slice(0, 10),
      headers: "",
      img: "https://api.vitech.asia/storage/upload/izin/",
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    openImg(url) {
      // console.log(url);
      window.open(url);
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    loadMore(pages) {
      try {
        axios
          .post(
            this.UrlApi + "listizin/all?page=" + pages,
            {
              jabatan: localStorage.getItem("jabatan"),
              id: localStorage.getItem("id"),
            },
            {
              headers: this.headers,
            }
          )
          .then((res) => {
            if (res.data.success && res.data.success !== null) {
              // this.dataEmpty = res.data.data.length > 0 ? true : false;
              if (res.data.data.length > 0) {
                this.page += 1;
                Array.prototype.push.apply(this.listOfizin, res.data.data);
                // console.log(this.listOfizin);
              } else {
                this.btnLoadMoreName = "Data Sudah Diload Seluruhnya";
                this.btnDisabled = true;
              }
            } else {
              Swal.fire({
                icon: "error",
                title: "Gagal!",
                text: res.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    getKontak() {
      try {
        axios
          .post(
            this.UrlApi + "pegawai/show",
            {
              id: this.id,
            },
            { headers: this.headers }
          )
          .then((res) => {
            if (res.data.success && res.data.success !== null) {
              this.kontak = res.data.data[0].no_tlp;
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log("error response");
            } else if (err.request) {
              console.log("error request");
            } else {
              console.log("error");
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    // batalkan(autono, id_peg, total_cuti) {
    //   console.log(autono, id_peg, total_cuti);
    //   Swal.fire({
    //     title: "Keterangan cuti dibatalkan ?",
    //     input: "textarea",
    //     inputPlaceholder: "Masukkan keterangan...",
    //     inputAttributes: {
    //       "aria-label": "Masukkan keterangan",
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: "Submit",
    //     showLoaderOnConfirm: true,
    //     preConfirm: (login) => {
    //       try {
    //         axios
    //           .post(
    //             this.UrlApi + "pengajuan/cuti/cancel",
    //             {
    //               id: autono,
    //               id_employee: id_peg,
    //               total_cuti: total_cuti,
    //               keterangan: login,
    //               jabatan: localStorage.getItem("jabatan"),
    //             },
    //             { headers: this.headers }
    //           )
    //           .then((res) => {
    //             if (res.data.success && res.data.success !== null) {
    //               Swal.fire({
    //                 icon: "success",
    //                 title: "Cuti Dibatalkan!",
    //                 text: res.data.message,
    //                 showConfirmButton: false,
    //                 timer: 1500,
    //               });
    //               window.location.reload();
    //               // console.log(res.data.success);
    //             } else {
    //               Swal.fire({
    //                 icon: "error",
    //                 title: "Gagal!",
    //                 text: res.data.message,
    //                 showConfirmButton: false,
    //                 timer: 1500,
    //               });
    //               // console.log(res);
    //             }
    //           })
    //           .catch((err) => {
    //             if (err.response) {
    //               console.log("error response");
    //             } else if (err.request) {
    //               console.log("error request");
    //             } else {
    //               console.log("error");
    //             }
    //           });
    //       } catch (error) {
    //         console.log(error);
    //       }
    //     },
    //     allowOutsideClick: () => !Swal.isLoading(),
    //   });
    // },
  },
  created() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("key"),
    };

    try {
      axios
        .post(
          this.UrlApi + "listizin/all?page=",
          {
            jabatan: localStorage.getItem("jabatan"),
            id: localStorage.getItem("id"),
          },
          { headers: this.headers }
        )
        .then((res) => {
          if (res.data.success && res.data.success !== null) {
            this.dataEmpty = res.data.data.length > 0 ? true : false;
            this.listOfizin = res.data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal!",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("error response");
          } else if (err.request) {
            console.log("error request");
          } else {
            console.log("error");
          }
        });
    } catch (error) {
      console.log(error);
    }

    this.getKontak();
  },
};
</script>
